import { defineMessages } from '@jutro/locale';

export default defineMessages({
    searchDocumentContents: {
        id: 'agent.directives.ml-create-edit-documents.Search Document Contents',
        defaultMessage: 'Search Document Contents'
    },
    asdfasdfasdfasd: {
        id: 'agent.directives.ml-create-edit-documents.You can search a document',
        defaultMessage: 'You can search a document by document form number, keyword, or by clicking the SEARCH button below to list all documents.'
    },
    documentFormNumber: {
        id: 'agent.directives.ml-create-edit-documents.Document Form Number',
        defaultMessage: 'Document Form Number'
    },
    keywords: {
        id: 'agent.directives.ml-create-edit-documents.Keywords',
        defaultMessage: 'Keywords'
    },
    search: {
        id: 'agent.directives.ml-document-search-btns.SEARCH',
        defaultMessage: 'SEARCH'
    },
    reset: {
        id: 'agent.directives.ml-document-search-btns.RESET',
        defaultMessage: 'RESET'
    },
    continue: {
        id: 'agent.directives.ml-create-edit-documents.CONTINUE',
        defaultMessage: 'CONTINUE'
    },
    createDraft: {
        id: 'agent.directives.ml-create-edit-documents.CREATE DRAFT',
        defaultMessage: 'CREATE DRAFT'
    },
    createDocument: {
        id: 'agent.directives.ml-create-edit-documents.CREATE DOCUMENT',
        defaultMessage: 'CREATE DOCUMENT'
    },
    cancel: {
        id: 'agent.directives.ml-create-edit-documents.CANCEL',
        defaultMessage: 'CANCEL'
    },
    searchResults: {
        id: 'agent.directives.ml-create-edit-documents.Search Results',
        defaultMessage: 'Search Results'
    },
    description: {
        id: 'agent.directives.ml-create-edit-documents.Description',
        defaultMessage: 'Description'
    },
    formNumber: {
        id: 'agent.directives.ml-create-edit-documents.Form Number',
        defaultMessage: 'Form Number'
    },
    documentSubtype: {
        id: 'agent.directives.ml-create-edit-documents.Document Subtype',
        defaultMessage: 'Document Subtype'
    },
    effectiveDate: {
        id: 'agent.directives.ml-create-edit-documents.Effective Date',
        defaultMessage: 'Effective Date'
    },
    expirationDate: {
        id: 'agent.directives.ml-create-edit-documents.Expiration Date',
        defaultMessage: 'Expiration Date'
    },
    loading: {
        id: 'agent.directives.ml-create-edit-documents.Loading',
        defaultMessage: 'Loading'
    },
    error: {
        id: 'agent.directives.ml-create-edit-documents.Error',
        defaultMessage: 'Error'
    },
    couldNotCreateDraft: {
        id: 'agent.directives.ml-create-edit-documents.Could not create draft',
        defaultMessage: 'Could not create draft'
    },
    close: {
        id: 'agent.directives.ml-create-edit-documents.Close',
        defaultMessage: 'Close'
    },
    
});
